import React from 'react';
import {
  Cpu,
  Car,
  Plug,
  Settings,
  TrainFront,
  Wrench,
} from 'lucide-react';

const areas = [
  { icon: Cpu, text: 'Power substation system design' },
  { icon: Car, text: 'Automobile harness design' },
  { icon: Plug, text: 'Switchgear/Switchboard design' },
  { icon: Settings, text: 'Electrical control system design' },
  { icon: TrainFront, text: 'Locomotive electrical schematic design' },
];

const tools = [
  { icon: Wrench, text: 'M-CAD' },
  { icon: Wrench, text: 'E-CAD' },
];

function TimelineItem({ icon: Icon, text, color }) {
  return (
    <div className="relative pl-10 before:absolute before:left-1 before:top-2.5 before:h-full before:w-0.5 before:bg-gray-300">
      <div className="flex items-start gap-4">
        <div className={`bg-${color}-100 text-${color}-600 p-2 rounded-full`}>
          <Icon className="w-5 h-5" />
        </div>
        <div className="text-gray-800 font-medium">{text}</div>
      </div>
    </div>
  );
}

function WorkingAreas() {
  return (
    <section className="bg-white text-gray-800 py-12 px-6">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl sm:text-4xl font-bold text-center mb-16 text-gray-900">
         Our Working Areas 
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {/* Domains - Left Column */}
          <div className="sm:ml-0 md:ml-8 lg:ml-20">
            <h3 className="text-2xl font-semibold mb-10 text-blue-700 text-center md:text-left">
              Domains
            </h3>
            <div className="space-y-8">
              {areas.map((item, idx) => (
                <TimelineItem
                  key={idx}
                  icon={item.icon}
                  text={item.text}
                  color="blue"
                />
              ))}
            </div>
          </div>

          {/* Tools - Right Column */}
          <div className="sm:ml-0 md:ml-8 lg:ml-14">
            <h3 className="text-2xl font-semibold mb-10 text-orange-600 text-center md:text-left">
              Tools & Software
            </h3>
            <div className="space-y-8">
              {tools.map((item, idx) => (
                <TimelineItem
                  key={idx}
                  icon={item.icon}
                  text={item.text}
                  color="orange"
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default WorkingAreas;
